import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

import styles from './styles';

function CheckboxGroupReview(props) {
  const { classes, values, title } = props;

  return (
    <div className={classes.container}>
      <Typography variant='body1'>{title}</Typography>
      <div className={classes.list}>
        {(values || []).map(({ label, id }, index) => (
          <>
            <Typography variant='subtitle1' key={id}>
              {label}
            </Typography>
            {index + 1 !== values.length && <span>|</span>}
          </>
        ))}
      </div>
    </div>
  );
}

CheckboxGroupReview.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(CheckboxGroupReview);
